export const CheckSafeHarborMessages = {
    validLocationFrequenciesAntennasInfoRequired:
        'Valid location, antenna, and frequency information are required to perform a Safe Harbor check',
} as const;
